/* NTXGlow "Afterglow" motion engine.
   Vanilla JS, no dependencies. Everything is progressive:
   if this file never runs, a 3s failsafe in theme.liquid removes .ag-js
   and every element is simply visible. */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var html = d.documentElement;
  w.__agMotion = true;

  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var finePointer = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var supportsSDA = !!(w.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  var hasIO = 'IntersectionObserver' in w;

  if (!supportsSDA && !reduce) html.classList.add('ag-no-sda');

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function rafThrottle(fn) {
    var queued = false;
    return function () {
      if (queued) return;
      queued = true;
      w.requestAnimationFrame(function () { queued = false; fn(); });
    };
  }
  function clamp(n, a, b) { return Math.min(b, Math.max(a, n)); }

  /* ---------- 1. Reveal on scroll ---------- */
  var revealIO = null;
  if (hasIO && !reduce && !design) {
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        revealIO.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
  }

  // Dawn sections we animate without editing their markup.
  var AUTO = [
    '.collection .title-wrapper-with-link',
    '.collection .grid__item',
    '.collection__view-all',
    '.footer__content-top .footer-block'
  ].join(',');

  function autoTag(scope) {
    if (!revealIO) return;
    var vh = w.innerHeight;
    each(scope.querySelectorAll(AUTO), function (el) {
      if (el.hasAttribute('data-ag-reveal')) return;
      if (el.closest('#ProductGridContainer, [data-ag-noreveal]')) return;
      // Only tag things that start below the fold, so nothing visible ever blinks.
      if (el.getBoundingClientRect().top < vh * 0.98) return;
      var i = Array.prototype.indexOf.call(el.parentNode.children, el) % 6;
      el.style.setProperty('--ag-d', i);
      el.setAttribute('data-ag-reveal', '');
    });
  }

  function reveal(scope) {
    each(scope.querySelectorAll('[data-ag-reveal]:not(.is-in)'), function (el) {
      if (revealIO) revealIO.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* ---------- 2. Count-up numbers ---------- */
  function fmt(n, plain) {
    n = Math.round(n);
    return plain ? String(n) : n.toLocaleString('en-US');
  }
  function counts(scope) {
    each(scope.querySelectorAll('[data-ag-count]'), function (el) {
      if (el.__agCount) return;
      el.__agCount = true;
      var end = parseFloat(el.getAttribute('data-ag-count'));
      var plain = el.getAttribute('data-ag-format') === 'plain';
      if (isNaN(end) || plain || reduce || design || !hasIO) return; // server-rendered final value stays
      // The final value stays in place until the stat scrolls in (it is still faded out
      // by the reveal at that moment), so nothing ever shows a stuck "0".
      var cio = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        cio.disconnect();
        el.textContent = fmt(0, plain);
        var start = null;
        var dur = 1400;
        function tick(t) {
          if (start === null) start = t;
          var p = clamp((t - start) / dur, 0, 1);
          var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p); // ease-out-expo
          el.textContent = fmt(end * eased, plain);
          if (p < 1) w.requestAnimationFrame(tick);
        }
        w.requestAnimationFrame(tick);
      }, { threshold: 0.1 });
      cio.observe(el);
    });
  }

  /* ---------- 3. Pointer spotlight ---------- */
  function spotlight(scope) {
    if (!finePointer || reduce) return;
    each(scope.querySelectorAll('.ag-spot'), function (el) {
      if (el.__agSpot) return;
      el.__agSpot = true;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (e.clientX - r.left).toFixed(0) + 'px');
        el.style.setProperty('--my', (e.clientY - r.top).toFixed(0) + 'px');
      }, { passive: true });
    });
  }

  /* ---------- 4. Scroll progress fallback (browsers without scroll timelines) ---------- */
  var scrollers = [];
  function registerScroll(scope) {
    if (supportsSDA || reduce) return;
    each(scope.querySelectorAll('[data-ag-scroll]'), function (el) {
      if (scrollers.indexOf(el) === -1) scrollers.push(el);
    });
    updateScroll();
  }
  function updateScroll() {
    var vh = w.innerHeight;
    for (var i = 0; i < scrollers.length; i++) {
      var el = scrollers[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      el.style.setProperty('--ag-p', p.toFixed(4));
    }
  }
  if (!supportsSDA && !reduce) {
    var onScroll = rafThrottle(updateScroll);
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---------- 5. Sticky story ---------- */
  function story(scope) {
    each(scope.querySelectorAll('[data-ag-story]'), function (sec) {
      if (sec.__agStory) return;
      sec.__agStory = true;
      var steps = sec.querySelectorAll('[data-ag-story-step]');
      var imgs = sec.querySelectorAll('[data-ag-story-img]');
      var bars = sec.querySelectorAll('[data-ag-story-bar]');
      function set(i) {
        each(steps, function (s, k) { s.classList.toggle('is-active', k === i); });
        each(imgs, function (m, k) { m.classList.toggle('is-active', k === i); });
        each(bars, function (b, k) { b.classList.toggle('is-done', k <= i); });
      }
      sec.__agStorySet = set;
      set(0);
      if (!hasIO) return;
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) set(parseInt(e.target.getAttribute('data-ag-story-step'), 10) || 0);
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      each(steps, function (s) { sio.observe(s); });
    });
  }

  /* ---------- 6. Horizontal rails ---------- */
  function rails(scope) {
    each(scope.querySelectorAll('[data-ag-rail-root]'), function (root) {
      if (root.__agRail) return;
      root.__agRail = true;
      var vp = root.querySelector('[data-ag-rail]');
      var prev = root.querySelector('[data-ag-prev]');
      var next = root.querySelector('[data-ag-next]');
      if (!vp) return;
      function page() {
        var item = vp.querySelector('.ag-rail__item');
        if (!item) return vp.clientWidth * 0.8;
        var stepW = item.getBoundingClientRect().width + 16;
        return Math.max(1, Math.floor((vp.clientWidth - 80) / stepW)) * stepW;
      }
      function update() {
        var max = vp.scrollWidth - vp.clientWidth - 2;
        if (prev) prev.disabled = vp.scrollLeft <= 2;
        if (next) next.disabled = vp.scrollLeft >= max;
      }
      function go(dir) { vp.scrollBy({ left: dir * page(), behavior: reduce ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      vp.addEventListener('scroll', rafThrottle(update), { passive: true });
      w.addEventListener('resize', rafThrottle(update), { passive: true });
      vp.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
      update();
    });
  }

  /* ---------- 7. Sticky buy bar (product pages) ---------- */
  function buybar() {
    var bar = d.querySelector('[data-ag-buybar]');
    if (!bar || bar.__agBar || !hasIO) return;
    var real = d.querySelector('product-info product-form .product-form__submit') ||
               d.querySelector('.product product-form .product-form__submit');
    if (!real) return;
    bar.__agBar = true;
    bar.hidden = false;
    var btn = bar.querySelector('[data-ag-buybar-btn]');
    var label = bar.querySelector('[data-ag-buybar-label]');
    var price = bar.querySelector('[data-ag-buybar-price]');

    function sync() {
      var p = d.querySelector('.product__info-container .price');
      if (p && price) {
        var sale = p.classList.contains('price--on-sale');
        var src = p.querySelector(sale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        if (src && src.textContent.trim()) price.textContent = src.textContent.trim();
      }
      var realLabel = real.querySelector('span');
      if (realLabel && label && realLabel.textContent.trim()) label.textContent = realLabel.textContent.trim();
      btn.disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
    }

    btn.addEventListener('click', function () {
      sync();
      if (btn.disabled) return;
      real.click();
    });

    var bio = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (show) sync();
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    bio.observe(real);

    var info = d.querySelector('.product__info-container');
    if (info && 'MutationObserver' in w) {
      new MutationObserver(rafThrottle(sync)).observe(info, {
        subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']
      });
    }
    sync();
  }

  /* ---------- Init ---------- */
  function init(scope) {
    autoTag(scope);
    reveal(scope);
    counts(scope);
    spotlight(scope);
    registerScroll(scope);
    story(scope);
    rails(scope);
  }

  function boot() {
    init(d);
    buybar();
    html.classList.add('ag-ready');
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor support */
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  d.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest && e.target.closest('[data-ag-story-step]');
    var sec = step && step.closest('[data-ag-story]');
    if (sec && sec.__agStorySet) sec.__agStorySet(parseInt(step.getAttribute('data-ag-story-step'), 10) || 0);
  });
})();